import { Navigate, useNavigate } from 'react-router-dom';
import { Button, Card } from '@promtver/ui-kit';

import { useAuth } from '../auth/AuthProvider';
import { ru } from '../i18n/ru';

/**
 * Экран «доступ ожидает подтверждения администратора».
 *
 * Показывается представителю предприятия, которому ещё не назначен объект:
 * заявка принята, учётная запись создана, но данных предприятия пока нет.
 * Вместо ошибки 403 пользователь видит, что происходит и когда ждать.
 */
export function PendingApprovalPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="mx-auto flex min-h-dvh max-w-panel flex-col justify-center gap-4 p-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-extrabold">{ru.pending.title}</h1>
        <p className="text-sm text-muted">{ru.pending.description}</p>
      </header>

      <Card>
        <div className="flex flex-col gap-3">
          {user?.email ? (
            <p className="text-xs text-muted">
              {ru.common.email}: <span className="font-mono text-content">{user.email}</span>
            </p>
          ) : null}
          <p className="text-xs text-muted">{ru.pending.hint}</p>
          <Button
            variant="outline"
            onClick={() => {
              logout();
              navigate('/login', { replace: true });
            }}
          >
            {ru.pending.loginLink}
          </Button>
        </div>
      </Card>
    </div>
  );
}
